/** The owner asks the native receiver to restart playback without replacing its pairing. */
export const TV_RECONNECT = 'tv:reconnect';
